// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","passenger":"passenger-yQM4Y","active":"active-3F9Kx","passengers":"passengers-2rrSi","checkbox":"checkbox-qwG3t","label":"label-2Xy5N"};